







































import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";

@Component({
  components: {}
})
export default class Login extends Vue {
  loading = false;
  userName = "Admin";
  password = "Lösenord1";
  customerCode = "ILOQ_18549";
  // userName = "";
  // password = "";
  // customerCode = "";
  errorMessage = "";

  authenticate() {
    this.loading = true;
    lockModule
      .createSession({
        userName: this.userName,
        password: this.password,
        customerCode: this.customerCode
      })
      .then(() => {
        console.log("ready");

        this.$router.push({ name: "Locks" });
      })
      .catch(error => {
        this.loading = false;
        this.errorMessage = error.response.data.Message;
        console.log(Object.keys(error));
      });
  }
}
